import { render } from "./About.vue?vue&type=template&id=1d6359bc"
const script = {}
script.render = render

export default script